<template>
  <div class="p-3 liff-reservation-confirm">
    <b-card header-tag="header" class="mb-3 wizard-mode-layout__card">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0">預約人資訊</h6>
        </div>
      </template>
      <b-form-group label="姓名" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3">
         <div class="text-right s-text-sm">{{ user.name }}</div>
      </b-form-group>
      <b-form-group v-if="user.mobile_phone" label="電話" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm">
        <div class="text-right s-text-sm">{{ user.mobile_phone }}</div>
      </b-form-group>
    </b-card>

    <b-card header-tag="header" class="mb-3 wizard-mode-layout__card">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0">預約資訊</h6>
        </div>
      </template>

      <b-form-group :label="dataModel.serviceField?.title" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="selectedServices.length">
        <div class="text-right s-text-sm">{{ selectedServices.map((service) => service.title).join(', ') }}</div>
      </b-form-group>

      <b-form-group label="服務人員" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="selectedStaff.name">
        <div class="text-right s-text-sm">{{ selectedStaff.name }}</div>
      </b-form-group>

      <b-form-group :label="dataModel.startTimeField?.title" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3">
        <div class="text-right s-text-sm">{{ selectedScheduleLabel }}</div>
      </b-form-group>

      <b-form-group label="預約結束時間" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="endDateTimeForDisplay && !dataModel.shouldHideEndTime">
        <div class="text-right s-text-sm">{{ endDateTimeForDisplay.format(dataModel.startAtFieldFormatIsDate ? 'YYYY-MM-DD' : 'YYYY-MM-DD HH:mm') }}</div>
      </b-form-group>

      <b-form-group :label="dataModel.branchField?.title" label-cols="4" label-cols-lg="2" label-size="sm" label-for="input-sm" class="mb-3" v-if="selectedBranch.name">
        <div class="text-right s-text-sm">{{ selectedBranch.name }}</div>
      </b-form-group>
    </b-card>

    <b-card header-tag="header" class="mb-3 wizard-mode-layout__card" v-if="fields.length > 0">
      <template #header>
        <div class="d-flex justify-content-between align-items-center">
          <h6 class="mb-0">其他資訊</h6>
        </div>
      </template>
      <b-form-group
        v-for="field in fields"
        :key="field._id"
        :label="field.title"
        label-cols="4"
        label-cols-lg="2"
        label-size="sm"
        label-for="input-sm"
        class="mb-3"
      >
        <div class="text-right s-text-sm">{{ extraFormData[field._id] }}</div>
      </b-form-group>
    </b-card>

    <div class="d-flex s-space-x-2">
      <SharedButton class="s-btn-outline-primary w-50" @click="handleNegativeButtonClicked">上一步</SharedButton>
      <SharedButton class="s-btn-bg-primary w-50" @click="handlePositiveButtonClicked" :disabled="!selectedSchedule.start_at">{{ dataModel.submitButtonText }}</SharedButton>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import Vue from 'vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import SharedButton from '@/components/Page/Liff/Shared/Button.vue';
import BookingPresetDataModel from '@/models/BookingPreset.model';
import DynamicFormField from '@/models/DynamicFormField.model';
import BookingBusinessLogic from '@/utils/booking/BookingBusinessLogic';

const bookingBusinessLogic = Vue.observable(new BookingBusinessLogic())

  export default {
    components: {
      SharedButton,
    },
    inject: ['back', 'proceed'],
    computed: {
      ...mapGetters('liffAuth', ['user']),
      ...mapGetters('liffBookingWizard', ['selectedServices']),
      ...mapState('liffBookingWizard', ['bookingPreset', 'availableServices', 'selectedBranch', 'selectedStaff', 'selectedServiceIds', 'selectedSchedule', 'extraFormData', 'selectedScheduleLabel']),
      dataModel() {
        return new BookingPresetDataModel(this.bookingPreset)
      },
      fields() {
        return DynamicFormField.fromArray(_.get(this.bookingPreset, 'config.fields', []))
          .filter(fieldModel => this.dataModel.customerVisibleFieldsInWizard(fieldModel))
          .map(fieldModel => ({
            disabled: true,
            ...fieldModel.flattenedAttributes()
          }));
      },
      serviceDuration() {
        return _.sumBy(this.selectedServices, 'duration')
      },
      endDateTimeForDisplay() {
        return bookingBusinessLogic.endDateTimeToSaveInWizard(this.selectedSchedule.start_at, this.serviceDuration)
      },
    },
    mounted() {
      this.init()
    },
    methods: {
      ...mapActions('liffBookingWizard', ['fetchBookingPreset']),
      async init() {
        await this.fetchBookingPreset({ bookingPresetId: this.$route.params.bookingPresetId, branchId: this.$route.query.branch_id })
        bookingBusinessLogic.setBookingPresetDataModel(this.dataModel)
      },
      handleNegativeButtonClicked() {
        this.back()
      },
      handlePositiveButtonClicked() {
        this.proceed()
      }
    }
  }
</script>
